import React, { useState, useEffect } from "react";
import { Container, Grid } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import api from "../../globals/axios";
import { useTranslation } from "react-i18next";
import CustomTextField from "../../components/Custom/CustomTextField";
import AddressForm from "../../components/Custom/AddressForm";
import LoaderContainer from "../../components/LoaderContainer";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../components/Alert";
import GenericButton from "../../components/Custom/GenericButton";
function ServiceProviderProfile() {
  const [profileData, setProfileData] = useState({
    full_name: "",
    phone_number: "",
    address: "",
    pin_code: "",
    state: "",
    district: "",
    post_office: "",
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { showAlert } = useAlert();
  const { t } = useTranslation();

  useEffect(() => {
    const loadDetails = async () => {
      try {
        const res = await api.get("/auth/appusers/");
        const userData = res.data[0];
        if (userData) {
          setProfileData({
            full_name: userData.full_name || "",
            phone_number: userData.phone_number || "",
            address: userData.address || "",
            pin_code: userData.address_data?.pin_code || "",
            state: userData.address_data?.state?.name || "",
            district: userData.address_data?.district?.name || "",
            post_office: userData.address_data?.postoffice?.name || "",
          });
        }
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };
    loadDetails();
  }, []);

  const handleChange = (name, value) => {
    setProfileData((prevData) => ({ ...prevData, [name]: value }));
  };
  const updateProfileData = (updatedData) => {
    setProfileData((prevData) => ({
      ...prevData,
      ...updatedData,
    }));
  };
  const handleAddressChange = (value) => {
    setProfileData({ ...profileData, address_line1: value });
  };

  const handleFieldChange = (name, value) => {
    setProfileData({ ...profileData, [name]: value });
  };

  const handleClick = async () => {
    try {
      await api
        .patch("/auth/appusers/self/", profileData)
        .then((res) => {
          if (res && res.data) {
            showAlert("success", "Profile Updated Successfully");
          }
          setTimeout(() => {
            navigate("/service-provider/additional-details");
          }, 1500);
        })
        .catch((err) => {
          console.error(err);
          showAlert("error", "Error on Updating Profile");
        });
    } catch (error) {
      console.error("Error on API Call:", error);
      showAlert("error", "Error on  Api Call");
    }
  };
  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container>
          <CustomTitle>{t("Personal Information")}</CustomTitle>

          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            <Grid item xs={12}>
              <CustomTextField
                label={t("Full Name")}
                value={profileData.full_name || ""}
                name="full_name"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomTextField
                label={t("Phone")}
                name="phone_number"
                value={profileData.phone_number || ""}
                onChange={handleChange}
                type="tel"
              />
            </Grid>

            <Grid item xs={12}>
              <AddressForm
                addressData={profileData.address} // Ensure this is the correct field
                handleAddressChange={handleAddressChange}
                showAllFields={true}
                t={t}
                handleFieldChange={handleFieldChange}
                profileData={profileData}
                updateProfileData={updateProfileData}
                fieldKeyMap={{
                  pin_code: "pin_code",
                  state: "state",
                  district: "district",
                  post_office: "post_office",
                  address: "address",
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <GenericButton
                onClick={handleClick}
                backgroundColor="#4CAF50"
                fontColor="white"
                padding="8px 0"
              >
                {t("Save")}
              </GenericButton>
            </Grid>
          </Grid>
        </Container>
      </LoaderContainer>
    </>
  );
}

export default ServiceProviderProfile;
